import { render, staticRenderFns } from "./BusDetail.vue?vue&type=template&id=3fae47a6&scoped=true"
import script from "./BusDetail.vue?vue&type=script&lang=js"
export * from "./BusDetail.vue?vue&type=script&lang=js"
import style0 from "./BusDetail.vue?vue&type=style&index=0&id=3fae47a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae47a6",
  null
  
)

export default component.exports